export default "__VITE_ASSET__BFTm4wu7__"